import { useCallback } from "react";
import { Popconfirm, Button, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { setting as settingService } from "@/services";

function WordStockDeleteButton({ wordId, token, callback }) {
  const confirmHandler = useCallback(() => {
    settingService
      .removeWordStock(wordId, token)
      .then(() => {
        message.success("删除成功");
        callback(Date.now());
      })
      .catch((err) => {
        message.error(err.message || err);
      });
  }, [wordId, token, callback]);
  return (
    <Popconfirm
      title="请确认是否删除?"
      onConfirm={confirmHandler}
      okText="是"
      cancelText="否"
    >
      <Button icon={<DeleteOutlined />} size="small" />
    </Popconfirm>
  );
}

export default WordStockDeleteButton;
